const EXCLUDED_PATH_PREFIXES = [
  '/auth',
  '/sign-up',
  '/login',
  '/verification-phone',
  '/checkout',
  '/lti',
];

export const isPhoneVerificationPromptRouteEligible = ({
  isInExternalPlatform,
  pathname,
}: {
  isInExternalPlatform: boolean;
  pathname: string;
}) =>
  !isInExternalPlatform &&
  !EXCLUDED_PATH_PREFIXES.some(prefix => pathname.startsWith(prefix));
